import { useData } from "../context/Data";
import { Bar } from "../components/common";
import { num } from "../lib/fmt";
import { tierInfo, useGo } from "./Inicio";

export const UNLOCK_LABEL = { survey: "📝 Encuestas, misiones y cartera", video: "📺 Ver vídeos recompensados", game: "🎮 Minijuegos", site: "🌐 Visitar páginas y campañas patrocinadas" };

export default function Vip() {
  const { d } = useData();
  const go = useGo();
  const t = tierInfo(d);
  return (
    <>
      <div className="page-intro"><div className="eyebrow">EVOLUCIONA CON TUS ACTIVIDADES</div><h1>💎 Programa VIP</h1><p className="lead">Para ascender hacen falta <b>las dos condiciones</b>: puntos XP <b>y</b> amigos realmente verificados. Cada ascenso desbloquea otra forma de participar y conservas todo lo ya desbloqueado.</p></div>
      <div className="card"><div className="flex"><div><div className="stat-label">Tu nivel actual</div><div className="stat-number lime" data-testid="vip-current-tier">{t.tier.name} {t.tier.icon}</div></div><div className="badge green" data-testid="vip-xp">{num(t.xp)} XP</div></div>
        <div className="dual-label"><span>⚡ XP {num(t.xp)} / {t.next ? num(t.next.xp) : "—"}</span><span>{Math.floor(t.xpPct)} %</span></div>
        <Bar pct={t.xpPct} testid="vip-xp-bar" />
        <div className="dual-label"><span>👥 Amigos verificados {d.valid_refs} / {t.next ? t.next.refs : "—"}</span><span>{Math.floor(t.refPct)} %</span></div>
        <Bar pct={t.refPct} testid="vip-refs-bar" />
        <div className="muted tiny" data-testid="vip-gap-text"><b>{t.gapText}</b></div></div>
      <div className="vip-grid">
        {d.config.tiers.map((x, i) => (
          <div key={x.key} className={`vip ${i === d.tier_idx ? "featured" : ""}`} data-testid={`vip-tier-${x.key}`}>
            <div className="big">{x.icon}</div><strong>{x.name}</strong><span className={`badge ${i <= d.tier_idx ? "green" : ""}`}>{i === 0 ? "Desde el registro" : `${num(x.xp)} XP · ${x.refs} amigos`}</span>
            <p>{UNLOCK_LABEL[x.unlock]}{i <= d.tier_idx ? " · ✅ desbloqueado" : " · 🔒"}</p>
          </div>
        ))}
      </div>
      <p className="section-foot">XP vigentes: +{d.config.xp.survey} por encuesta validada, +{d.config.xp.referral} por referido válido, +{d.config.xp.checkin} por check-in, +{d.config.xp.video} por vídeo/sitio verificado y +{d.config.xp.game} por minijuego. Los requisitos de amigos solo afectan al avance VIP, nunca al cobro de un saldo ya retirable. <button className="text-link" onClick={() => go("actividades")}>Ver actividades desbloqueables →</button></p>
    </>
  );
}
